import { fetchApi } from 'shared/functions/fetchApi';

const delay = time => new Promise(response => setTimeout(response, time));

export const downloadServiceWithRetries = async (path, retries) => {
  let error;

  // We wait 5 seconds before the next request because the document is being generated
  // in the database right now. If the document is generated then it will be returned
  // immediately and the loop will end
  for (let i = 0; i < retries; i += 1) {
    try {
      /* eslint-disable no-await-in-loop */
      if (i !== 0) await delay(5000);
      return await fetchApi(path).then(res => res.json());
      /* eslint-disable no-await-in-loop */
    } catch (err) {
      error = err;
    }
  }

  throw error;
};
